import { useLoading } from '../../../Contexts/LoadingContext'
import Loading from './Loading'

const LoadingContainer = (props) => {
  const { isLoading } = useLoading()
  return <Loading show={isLoading} color={props.color} />
}

export default LoadingContainer
